export default {
  data() {
    return {
      table: {
        styleClass: 'table table-hover',
        rows: null,
        paginate: true,
        rowsPerPageText: this.$t('common.tablePerPage'),
        ofText: this.$t('common.tableOf'),
        allText: this.$t('common.tableAll'),
        prevText: this.$t('common.tablePrev'),
        nextText: this.$t('common.tableNext'),
        onClick: this.onTableClick,
        rowStyleClass: this.tableRowStyle,
        ref: 'goodtable',
      },
    };
  },

  methods: {
    onTableClick(row, index) {
      this.selectRow(row, index);
    },

    selectRow(row, index) {
      this.setAriaSelected(index);
    },

    setAriaSelected(index) {
      this.$nextTick(() => {
        if (this.$refs.goodtable) {
          // TODO pl: in page is reloaded and selection is restored, due to the transition the $refs
          // will not be present. So in this case we can't set aria selected!
          // Ideal solution would be to add a row-select feature directly into vue-good-table
          // and use aria-selected there!
          const rows = this.$refs.goodtable.$refs.table.querySelectorAll('tr.clickable');
          /** NOTE: this cannot be .forEach becausequerySelectorAll returns NodeList
           * which is incompatible to forEach (in IE11)
           * More details see https://stackoverflow.com/questions/41142932/ie-supports-foreach-when-invoked-fromthe-console-but-not-when-called-from-t
           */
          for (let i = 0; i < rows.length; i += 1) {
            if (i === index) {
              rows[i].setAttribute('aria-selected', true);
            } else {
              rows[i].removeAttribute('aria-selected');
            }
          }
        }
      });
    },

    tableRowStyle() {
      return '';
    },
  },

  computed: {
    isTableFilled() {
      return !!this.table.rows;
    },
  },
};
